import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ClientContainer from '../../ClientContainer';
import BannerStrip from '../../Common/Containers/BannerStrip';
import InspectionsTable from './InspectionsTable';
import PermitInspectionsDetails from './PermitInspectionsDetails';
import useCloseDrawers from '../../../hooks/useCloseDrawers';
import useShowDetailsFromDashboard from '../../../hooks/useShowDetailsFromDashboard';
import { RootState } from '../../../../../redux/root';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';
import { ModalDefaultDraggable } from '../../../../../molecules';

const Inspections = () => {
  useCloseDrawers();
  useShowDetailsFromDashboard();
  const dispatch = useDispatch();
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const selectedPermit = useSelector((s: RootState) => s.inspections.selectedPermit);

  const handleClose = () => dispatch(setShowDrawerContent(false));

  const title = selectedPermit?.namePermitName || 'Permit Inspections';

  return (
    <ClientContainer>
      <BannerStrip label="Inspections" />
      <TableStage>
        <InspectionsTable />
      </TableStage>
      {showDrawerContent && (
        <ModalDefaultDraggable title={title} onClose={handleClose} extraWide addContactModal>
          <PermitInspectionsDetails />
        </ModalDefaultDraggable>
      )}
    </ClientContainer>
  );
};

export default Inspections;

const TableStage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
